import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@client';
import TableRequest from '../../../../../../types/TableRequest';
import { TerminalResponse } from '@module/terminal/model/TerminalResponse';
import { PortResponse } from '@state/types/PortResponse';

interface FetchPortTerminalsRequest {
  portId: number;
  params: TableRequest;
}

interface FetchPortByIdRequest {
  portId: number;
}

export const portsApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ['PortAnalysisPorts'],
  reducerPath: 'portAnalysisPorts_api',
  endpoints: (build) => ({
    fetchPortById: build.query<PortResponse, FetchPortByIdRequest>({
      query: ({ portId }) => ({
        url: `/secured/port/${portId}/load`,
        method: 'GET'
      })
    }),
    fetchPortTerminals: build.query<
      TerminalResponse[],
      FetchPortTerminalsRequest
    >({
      query: ({ portId, params }) => ({
        url: `/secured/ports/${portId}/terminals`,
        method: 'GET',
        params
      })
    })
  })
});

export const { useFetchPortByIdQuery, useFetchPortTerminalsQuery } = portsApi;
